import React from 'react';
import styled from 'styled-components';

import theme from '@styles/theme';

const Container = styled.div`
  display: inline-block;

  .switch {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 17px;
  }

  .switch input {
    display: none;
  }

  .include-in-budget-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 34px;
  }

  .include-in-budget-slider:before {
    position: absolute;
    content: '';
    height: 13px;
    width: 13px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .include-in-budget-slider {
    background-color: ${theme.colors.primary};
  }

  input:focus + .include-in-budget-slider {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + .include-in-budget-slider:before {
    -webkit-transform: translateX(13px);
    -ms-transform: translateX(13px);
    transform: translateX(13px);
  }
`;

export default class Switch extends React.PureComponent {
  render() {
    const { onClick, checked, disabled = false } = this.props;

    return (
      <Container>
        <label className="switch">
          <input
            type="checkbox"
            disabled={disabled}
            checked={checked}
            onChange={e => {
              e.stopPropagation();
              onClick(e.target.checked);
            }}
          />
          <span className="include-in-budget-slider" />
        </label>
      </Container>
    );
  }
}
